import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { get } from 'session';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { ucwords } from 'helper';
import BusinessActivity from './RenewalAssessApplication/BusinessActivity';
import NewBusinessActivityList from './RenewalAssessApplication/NewBusinessActivity/BusinessActivityList';
import * as c from '../constant';
import * as actions from '../actions';

const commonValidation = {
  base_line: 'required',
  area: 'required',
  floor_area: 'required',
  no_of_employees_residing_manila: 'required',
  no_of_male_employees: 'required',
  no_of_female_employees: 'required',
  no_of_van: 'required',
  no_of_truck: 'required',
  no_of_motorcycle: 'required',
};

const INIT_STATE = {
  base_line: '',
  veterinary_fee_id: '',
  calculation_details: {},
  area: '',
  floor_area: '',
  no_of_male_employees: '',
  no_of_female_employees: '',
  no_of_employees: '',
  no_of_employees_residing_manila: '',
  no_of_van: '',
  no_of_truck: '',
  no_of_motorcycle: '',
  details: {},
};

function UpdateModal({
  assessRenewApplication,
  id,
  history,
  getItem,
  updating,
  updateList,
  getVetRegistrationList,
  vetRegistrationList,
  getBusinessNecessaryField,
  businessNecessaryField,
  getBusinessActivityList,
  businessActivityList,
  getCalculationDetailsList,
  getCheckBarangayClearance,
  checkBarangayClearance,
}) {
  const applicationStatusId = get('applicationStatusId') || 0;
  const [formData, setFormData] = useState(INIT_STATE);
  const formDetails = _.get(formData, 'details', {});
  const bplsBusiness = _.get(updateList, 'included.bplsBusiness', {});
  const bplsBusinessAttr = _.get(bplsBusiness, 'attributes', {});
  const businessDetails = _.get(bplsBusinessAttr, 'details', {});
  const [calculations, setCalculations] = useState({});
  const setModal = useContext(ModalContext);
  const [formDataQuantityMatrix, setFormDataQuantityMatrix] = useState({});
  const quantity_matrix = _.get(businessDetails, 'quantity_matrix', []);
  const multiplierQuantityMatrix = Object.values(quantity_matrix ?? {})
    .flatMap(item => _.isArray(item) ? item : [])
    .reduce((acc, { multiplier, value }) => {
      if (multiplier && !Number.isNaN(value)) {
        acc[multiplier] = +value;
      }
      return acc;
    }, {});

  const listOption =
    vetRegistrationList.map((item) => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };
  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);

  const checkBarangayClearancePayload = {
    barangay_code: _.get(formData, 'main_office_barangay_code') || 0,
    transaction_type:
      _.get(updateList, 'included.bplsBusiness.attributes.type') || 'RENEWAL',
  };

  const validateForm = useFormValidator(formData, commonValidation);
  const validateCalculations = useFormValidator(calculations, {});
  const validateBusinessNecessary = useFormValidator(formDetails, {});

  const checkNumberOfEmployees = (employeesData) => {
    if (
      _.get(updateList, 'attributes.no_of_employees') === 0 ||
      _.get(updateList, 'attributes.no_of_employees') === '0'
    )
      return '0';
    if (
      _.get(updateList, 'attributes.no_of_employees') !== 0 ||
      _.get(updateList, 'attributes.no_of_employees') !== '0'
    ) {
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') !== 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') !== 0)
      )
        return '0';
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') === 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') === 0)
      )
        return '';
    }
    return employeesData;
  };

  useEffect(() => {
    getVetRegistrationList();
    getBusinessActivityList(id);

    if (!_.isEmpty(updateList)) {
      const businessAttr = _.get(
        updateList,
        'included.bplsBusiness.attributes'
      );
      setFormData({
        ...formData,
        base_line: _.get(businessAttr, 'base_line') || '0',
        calculation_details: _.get(businessAttr, 'calculation_details') || {},
        veterinary_fee_id: _.get(businessAttr, 'veterinary_fee_id') || '',
        area: _.get(businessAttr, 'area') || '',
        floor_area: _.get(businessAttr, 'floor_area') || '',
        no_of_employees:
          // eslint-disable-next-line eqeqeq
          _.get(businessAttr, 'no_of_employees') == 0
            ? '0'
            : _.get(businessAttr, 'no_of_employees') || '',
        // eslint-disable-next-line eqeqeq
        no_of_employees_residing_manila:
          checkNumberOfEmployees(
            _.get(businessAttr, 'no_of_employees_residing_manila')
          ) || '',
        no_of_male_employees:
          // eslint-disable-next-line eqeqeq
          _.get(businessAttr, 'no_of_employees') == 0
            ? '0'
            : `${_.get(businessAttr, 'no_of_male_employees')}` || '',

        no_of_female_employees:
          // eslint-disable-next-line eqeqeq
          _.get(businessAttr, 'no_of_employees') == 0
            ? '0'
            : `${_.get(businessAttr, 'no_of_female_employees')}` || '',
        no_of_vehicles: _.get(businessAttr, 'no_of_vehicles') || '0',
        no_of_van: _.get(businessAttr, 'no_of_van') || '0',
        no_of_truck: _.get(businessAttr, 'no_of_truck') || '0',
        no_of_motorcycle: _.get(businessAttr, 'no_of_motorcycle') || '0',
        main_office_barangay_code:
          _.get(businessAttr, 'main_office_barangay_code') || '',
        with_barangay_clearance:
          _.get(
            updateList,
            'included.bplsApplication.attributes.with_barangay_clearance'
          ) || 0,
      });
    }

    if (!_.isEmpty(_.get(formData, 'main_office_barangay_code'))) {
      getCheckBarangayClearance(checkBarangayClearancePayload);
    }
  }, []);

  useEffect(() => {
    if (!applicationStatusId) return;
    const query = { application_status_id: applicationStatusId };
    getBusinessNecessaryField(query, ({ data: necessaryFields }) => {
      if (!necessaryFields || isEmpty(necessaryFields)) return;
      const details = necessaryFields.reduce((acc, item) => {
        const multiplier = _.get(item, 'multiplier');
        const options = _.get(item, 'options');
        const value = businessDetails[multiplier];
        acc[multiplier] = options && !value ? '' : value;
        return acc;
      }, {});

      const businessNecessaryValidation = Object.keys(details).reduce(
        (acc, item) => {
          acc[item] = 'required';
          return acc;
        },
        {}
      );
      validateBusinessNecessary.onSetObjectRules(businessNecessaryValidation);
      validateBusinessNecessary.validate();

      setFormData((prev) => ({
        ...prev,
        details,
      }));
    });
  }, [applicationStatusId]);

  useEffect(() => {
    validateForm.validate();
  }, [JSON.stringify(formData)]);

  useEffect(() => {
    validateCalculations.validate();
  }, [JSON.stringify(calculations)]);

  useEffect(() => {
    validateBusinessNecessary.validate();
  }, [JSON.stringify(formDetails)]);

  useEffect(() => {
    const args = {
      main_office_barangay_code:
        _.get(
          updateList,
          'included.bplsBusiness.attributes.main_office_barangay_code'
        ) ||
        _.get(formData, 'main_office_barangay_code') ||
        0,
      with_barangay_clearance:
        _.get(
          updateList,
          'included.bplsApplication.attributes.with_barangay_clearance'
        ) ||
        _.get(formData, 'with_barangay_clearance') ||
        0,
    };

    getCalculationDetailsList(id, args, ({ res }) => {
      const calcValidation = Object.keys(res).reduce((acc, item) => {
        acc[item] = 'required|number';
        return acc;
      }, {});
      validateCalculations.onSetObjectRules(calcValidation);
      setCalculations(res);
    });
  }, [
    _.get(formData, 'main_office_barangay_code'),
    _.get(formData, 'with_barangay_clearance'),
  ]);

  useEffect(() => {
    if (!_.isEmpty(_.get(formData, 'main_office_barangay_code'))) {
      getCheckBarangayClearance(checkBarangayClearancePayload);
    }
  }, [_.get(formData, 'main_office_barangay_code')]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (
      !validateForm.response.is_passed &&
      !validateCalculations.response.is_passed &&
      !validateBusinessNecessary.response.is_passed
    ) {
      return false;
    }

    const businessNecessary = {
      ...formData.details,
      quantity_matrix: formDataQuantityMatrix,
    };

    const args = {
      ...formData,
      calculation_details: calculations,
      details: businessNecessary,
    };

    return assessRenewApplication(id, args, () => {
      const pathName = history.location.pathname;
      setModal({ isOpen: false });
      getItem(id);

      if (pathName.indexOf('/bpls/applications/renewal') > -1) {
        return history.push(`/bpls/applications/renewal/${id}`);
      }
      return history.push(`/bpls/applications/new/${id}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const onChangeCalculation = (prop) => {
    const { name, value } = prop;
    setCalculations((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const onChangeBusinessNecessary = (prop) => {
    const { name, value } = prop;
    setFormData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        [name]: value,
      },
    }));
  };

  useEffect(() => {
    if (!_.isEmpty(multiplierQuantityMatrix)) {
      setFormDataQuantityMatrix({
        ...formDataQuantityMatrix,
        ...multiplierQuantityMatrix,
      });
    }
  }, []);

  const onChangeQuantityMatrix = (key, value) => {
    setFormDataQuantityMatrix({
      ...formDataQuantityMatrix,
      [key]: value
    });
  };

  const onSelectDetails = (key) => (e) => {
    setFormData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        [key]: e.value,
      },
    }));
  };

  const selectOptions = (list) => {
    const newList = [];

    if (_.isEmpty(list)) return false;

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  const filteredBusinessNecessaryField = businessNecessaryField.filter(
    (item) => !item.quantity_matrix
  );

  const filteredQuantityMatrix = businessNecessaryField.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="container">
          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Business Operation
          </div>

          <div className="row">
            {c.BUSINESS_OPERATIONS_FIELD.map((constant) => (
              <div className="col-6 form-group" key={constant.key}>
                <label htmlFor={constant.key} className="form-label mb-0">
                  {constant.label}: {validateForm.renderMessage(constant.key)}
                </label>
                <NumberFormat
                  className="form-control"
                  name={constant.key}
                  id={constant.key}
                  placeholder="0"
                  disabled={constant.disabled}
                  displayType="input"
                  thousandSeparator
                  decimalScale={constant.decimalScale}
                  prefix=""
                  value={_.get(formData, constant.key)}
                  onValueChange={({ floatValue }) => {
                    onChange(constant.key, floatValue);
                  }}
                />
              </div>
            ))}

            {filteredBusinessNecessaryField.map((item) => {
              const options = _.get(item, 'options');
              const multiplier = _.get(item, 'multiplier');
              const optionLabel = ucwords(multiplier ?? '').replace(/_/g, ' ');
              const badge = validateBusinessNecessary.renderMessage(multiplier);

              if (options) {
                const selectValue = selectOptions(options).find((option) => {
                  const optionValue = _.get(option, 'value');
                  const formDetailsValue = _.get(formDetails, multiplier);
                  return formDetailsValue === optionValue;
                });
                return (
                  <div className="col-6 form-group" key={multiplier}>
                    <label className="form-label mb-0">
                      {optionLabel} {badge}
                    </label>
                    <Select
                      name={multiplier}
                      options={selectOptions(options)}
                      onChange={onSelectDetails(multiplier)}
                      components={{ IndicatorSeparator: () => null }}
                      value={selectValue}
                    />
                  </div>
                );
              }

              const inputValue = _.get(formDetails, multiplier);
              return (
                <div className="col-6 form-group" key={multiplier}>
                  <label htmlFor={multiplier} className="form-label mb-0">
                    {optionLabel} {badge}
                  </label>
                  <NumberFormat
                    className="form-control"
                    name={multiplier}
                    id={multiplier}
                    placeholder="0"
                    displayType="input"
                    thousandSeparator
                    decimalScale={2}
                    prefix=""
                    value={inputValue}
                    onValueChange={({ floatValue }) => {
                      const prop = {
                        name: multiplier,
                        value: floatValue,
                      };
                      onChangeBusinessNecessary(prop);
                    }}
                  />
                </div>
              );
            })}

            {!_.isEmpty(filteredQuantityMatrix) ? (
              filteredQuantityMatrix.map((item) => {
                const multiplier = _.get(item, 'multiplier', '');

                return (
                  <React.Fragment>
                    <div className='form-group col-12 mb-0'>
                      <label className='form-label mb-0 text-capitalize'>
                        {multiplier}
                      </label>
                    </div>
                    <div className='w-100 border rounded-lg mx-3'>
                      <table className="table table-borderless table-sm table-striped table-hover mb-0">
                        <thead>
                          <tr className="form-group">
                            <td className="col-4 form-label text-center border-right">Unit</td>
                            <td className="col-4 form-label text-center border-right">Capacity</td>
                            <td className="col-4 form-label text-center">Number of Units</td>
                          </tr>
                        </thead>
                        <tbody>
                          {item.quantity_matrix.map((quantityMatrixItem) => {
                            const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <tr
                                key={quantityMatrixMultiplier}
                                className="border-top form-group"
                              >
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'unit')}
                                </td>
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'capacity')}
                                </td>
                                <td className="col-4 text-left form-label">
                                  <NumberFormat
                                    name={quantityMatrixMultiplier}
                                    id={quantityMatrixMultiplier}
                                    className="form-control"
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      onChangeQuantityMatrix(quantityMatrixMultiplier, floatValue);
                                    }}
                                    displayType="input"
                                    thousandSeparator
                                    allowLeadingZeros
                                    isNumericString
                                    value={_.get(formDataQuantityMatrix, `${quantityMatrixMultiplier}`)}
                                  />
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                )
              })
            ) : (
              ''
            )}

            {_.get(checkBarangayClearance, 'with_barangay_clearance') ? (
              <div className="col-12 form-group">
                <input
                  className="mx-0 mb-2"
                  name="with_barangay_clearance"
                  type="checkbox"
                  checked={_.get(formData, 'with_barangay_clearance') || ''}
                  onChange={onCheck}
                />
                <label className="form-label m-0 py-2 ml-2 font-medium">
                  Barangay Clearance
                </label>
              </div>
            ) : (
              ''
            )}
          </div>

          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Calculation Details
          </div>

          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="veterinary_fee_id" className="form-label mb-0">
                Veterinary Registration:{' '}
              </label>
              <Select
                name="veterinary_fee_id"
                placeholder="Select"
                onChange={handleOnChangeSelect('veterinary_fee_id')}
                options={vetRegistrationListOption}
                isClearable
                value={
                  vetRegistrationListOption.find((item) => {
                    return (
                      `${_.get(formData, 'veterinary_fee_id')}` ===
                      _.get(item, 'value')
                    );
                  }) || ''
                }
              />
            </div>

            <div className="col-6 form-group">
              <label htmlFor="base_line" className="form-label mb-0">
                Base Line: {validateForm.renderMessage('base_line')}
              </label>
              <NumberFormat
                className="form-control"
                name="base_line"
                id="base_line"
                placeholder="0"
                displayType="input"
                thousandSeparator
                decimalScale={2}
                prefix=""
                value={_.get(formData, 'base_line') || '0'}
                disabled
              />
            </div>

            {Object.entries(calculations).map((item) => {
              return (
                <div key={item[0]} className="col-6 form-group">
                  <label className="form-label mb-0">
                    {ucwords(item[0].replace(/_/g, ' '))}:{' '}
                    {validateCalculations.renderMessage(item[0])}
                  </label>
                  <NumberFormat
                    name={item[0]}
                    id={item[0]}
                    placeholder="0.00"
                    className="form-control"
                    onValueChange={(values) => {
                      const { value } = values;
                      const prop = {
                        name: item[0],
                        value,
                      };
                      onChangeCalculation(prop);
                    }}
                    displayType="input"
                    decimalScale={2}
                    isNumericString
                    allowNegative
                    thousandSeparator
                    allowLeadingZeros
                    prefix="₱ "
                    value={_.get(calculations, item[0])}
                    isAllowed={(values) => {
                      const { value } = values;
                      if (!value) return true;
                      const val = new Decimal(value);
                      const max = new Decimal(MAX_LIMIT);
                      return value === undefined || val.lte(max);
                    }}
                  />
                </div>
              );
            })}
          </div>

          <div className="row ml-auto text-primary font-weight-bold mb-3">
            Business Activities
          </div>
          <div className="form-wrapper p-3 mb-3">
            <BusinessActivity
              businessActivityList={businessActivityList}
              businessId={id}
            />
          </div>
          <div className="form-wrapper p-3">
            <NewBusinessActivityList businessId={id} />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              !validateCalculations.response.is_passed ||
              businessActivityList.some(
                (obj) => !_.get(obj, 'attributes.is_validated')
              )
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  assessRenewApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
  getBusinessNecessaryField: PropTypes.instanceOf(Function).isRequired,
  businessNecessaryField: PropTypes.instanceOf(Object).isRequired,
  getBusinessActivityList: PropTypes.instanceOf(Function).isRequired,
  businessActivityList: PropTypes.instanceOf(Array).isRequired,
  getCalculationDetailsList: PropTypes.instanceOf(Function).isRequired,
  getCheckBarangayClearance: PropTypes.instanceOf(Function).isRequired,
  checkBarangayClearance: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  vetRegistrationList: _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
  businessNecessaryField:
    _.get(api, `${c.GET_BUSINESS_NECESSARY_FIELD}.list`) || [],
  businessActivityList:
    _.get(api, `${c.GET_BUSINESS_ACTIVITY_LIST}.list`) || [],
  checkBarangayClearance:
    _.get(api, `${c.GET_CHECK_BARANGAY_CLEARANCE}.res`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
